/* ============
 * Catalogue Transformer
 * ============
 *
 * The transformer for the catalogues.
 */

import Transformer from './transformer';

export default class catalogueTransformer extends Transformer {

  static fetch(catalogues) {
    return {
      id: catalogues.id,
      clientId: catalogues.client_id,
      actionCode: catalogues.action_code,
      productGroupId: catalogues.product_group_id,
      name: catalogues.name,
      issuedAt: catalogues.issued_at,
      versionId: catalogues.version_id,
      validFrom: catalogues.valid_from,
      validTo: catalogues.valid_to,
      reference: catalogues.reference,
      note: catalogues.note,
    };
  }

  static send(catalogues) {
    return {
      id: catalogues.id,
      client_id: catalogues.clientId,
      action_code: catalogues.actionCode,
      product_group_id: catalogues.productGroupId,
      name: catalogues.name,
      issued_at: catalogues.issuedAt,
      version_id: catalogues.versionId,
      valid_from: catalogues.validFrom,
      valid_to: catalogues.validTo,
      reference: catalogues.reference,
      note: catalogues.note,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/catalogue.js